import { render } from "./ProviderModule.vue?vue&type=template&id=01a1e21c&ts=true"
import script from "./ProviderModule.vue?vue&type=script&lang=ts"
export * from "./ProviderModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__